export enum AppointmentJourney {
  CustomerBooked = 'CustomerBooked',
  SelfBooked = 'SelfBooked',
  SomeoneSpecific = 'SomeoneSpecific',
  SomeoneElse = 'SomeoneElse',
}
